import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import App from "../../App";
import Spinner from "react-bootstrap/Spinner";
import { connect } from "react-redux";
import { AddAccessToken } from "../redux/Actions/AccessTokenActions";

//login component which shows by default if there is no user data on localstorege

const Login = (props) => {
  // Login Component will show on /login url
  const history = useHistory();
  const [userCredentials, setCredentials] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const { email, password } = userCredentials;
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();

  const toastMessagePopUp = (message) => {
    // Shows toast error message popup
    toast.error(message, {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  //axios request to find out if user credentials are valid or not, if response is ok then the home.js callback function props.loginUser(); is called
  const handleSubmit = async (event) => {
    setLoading(true);
    event.preventDefault();
    axios
      .post(
        App.baseUrl + "auth",
        { email, password },
        {
          cancelToken: source.token,
        }
      )
      .then((response) => {
        // saves the access token to redux using AddAccessToken()
        props.loginloader();
        props.AddAccessToken(response.data.access_token);
        props.loginUser();
      })
      .catch((error) => {
        if (error.response) {
          toastMessagePopUp(error.response.data.message);
        } else {
          toastMessagePopUp(
            "Something went wrong, please check your Internet connection or refresh the page"
          );
        }
        setLoading(false);
      });
  };

  // call on cleanup
  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  //handle change method for login
  const handleChange = (event) => {
    const { value, name } = event.target;
    setCredentials({ ...userCredentials, [name]: value });
  };

  return (
    <div className="background-image">
      {loading ? (
        <Spinner animation="border" id="spinner-loading-show" />
      ) : (
        <div>
          <div className="line-color-background">
            <span className="please-login">PLEASE</span>
          </div>
          <Container fluid>
            <Row>
              <Col xs={1} />
              <Col xs={10}>
                <div className="login-text-details">LOGIN</div>
                <Form onSubmit={handleSubmit}>
                  <Form.Group>
                    <Form.Label>Email address</Form.Label>
                    <Form.Control
                      id="form-ctrl-email"
                      name="email"
                      value={email}
                      onChange={handleChange}
                      type="email"
                      placeholder="Enter email"
                      autoComplete="email"
                    />
                  </Form.Group>

                  <Form.Group>
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      name="password"
                      id="form-ctrl-password"
                      value={password}
                      onChange={handleChange}
                      type="password"
                      placeholder="Password"
                      autoComplete="current-password"
                    />
                  </Form.Group>
                  <div>
                    <Link id="login-register-link" to="/register">
                      {" "}
                      Don't have an account ?
                    </Link>
                    <Button
                      id="buttonedit"
                      type="submit"
                      disabled={!email || !password}
                    >
                      Login
                    </Button>
                  </div>
                </Form>
              </Col>
              <Col xs={1} />
            </Row>
          </Container>
        </div>
      )}

      {/* toaster container */}

      <ToastContainer
        limit={1}
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    AddAccessToken: (data) => dispatch(AddAccessToken(data)),
  };
};

export default connect(null, mapDispatchToProps)(Login);
